/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateLegalEntity200Response
 */
export interface ValidateLegalEntity200Response {
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntity200Response
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntity200Response
     */
    companyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateLegalEntity200Response
     */
    isValid: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntity200Response
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the ValidateLegalEntity200Response interface.
 */
export function instanceOfValidateLegalEntity200Response(value: object): value is ValidateLegalEntity200Response {
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    return true;
}

export function ValidateLegalEntity200ResponseFromJSON(json: any): ValidateLegalEntity200Response {
    return ValidateLegalEntity200ResponseFromJSONTyped(json, false);
}

export function ValidateLegalEntity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateLegalEntity200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'taxId': json['taxId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'isValid': json['isValid'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function ValidateLegalEntity200ResponseToJSON(json: any): ValidateLegalEntity200Response {
    return ValidateLegalEntity200ResponseToJSONTyped(json, false);
}

export function ValidateLegalEntity200ResponseToJSONTyped(value?: ValidateLegalEntity200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taxId': value['taxId'],
        'companyName': value['companyName'],
        'isValid': value['isValid'],
        'errorMessage': value['errorMessage'],
    };
}

